// src/app/slices/erWheelSlice.ts
import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { ErWheelState, IErWheel, IErWheelParams } from '../models';

const initialState: ErWheelState = {
  erWheels: {},
 er_wheel_params: null,
};

const erWheelSlice = createSlice({
  name: 'er_wheel',
  initialState,
  reducers: {
    setErWheel: (state, action: PayloadAction<IErWheel>) => {
      state.erWheels[action.payload.id] = {
        ...action.payload,
        params: action.payload.energy_wheel_params
          ? JSON.parse(action.payload.energy_wheel_params)
          : '',
      };
    },
    setErWheelParams: (state, action: PayloadAction<IErWheelParams>) => {
      state.er_wheel_params = action.payload;
    },
  },
});

export const { setErWheel, setErWheelParams } = erWheelSlice.actions;

export default erWheelSlice.reducer;
